import { useState, useEffect } from "react";
import { useLocation, useNavigate, useSearchParams } from "react-router";

export const useSearchField = (paramName = "filter", debounceMs = 300) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const [value, setValue] = useState(() => searchParams.get(paramName) ?? "");
  const currentFilter = searchParams.get(paramName);

  useEffect(() => {
    const id = setTimeout(() => {
      if (value === (currentFilter ?? "")) {
        return;
      }

      void navigate(
        {
          search: value ? `?${paramName}=${encodeURIComponent(value)}` : "",
        },
        { replace: true, state: location.state },
      );
    }, debounceMs);
    return () => clearTimeout(id);
  }, [currentFilter, debounceMs, location.state, navigate, paramName, value]);

  return {
    value,
    onChange: (e: React.ChangeEvent<HTMLInputElement>) =>
      setValue(e.currentTarget.value),
    currentFilter,
    clear: () => {
      setValue("");
      if (currentFilter !== null) {
        void navigate({ search: "" }, { replace: true, state: location.state });
      }
    },
  };
};
